/// <reference types="vite/client" />

import { compressExerciseVideo } from './compress-video.ts';

type UploadExerciseVideoDeps = {
  compress?: typeof compressExerciseVideo;
  postJson?: (url: string, body?: unknown) => Promise<unknown>;
  name?: string;
};

async function defaultPostJson<T>(url: string, body?: unknown): Promise<T> {
  const { default: client } = await import('../api/client');
  const { data } = await client.post<T>(url, body, { skipOffline: true });
  return data;
}

export async function uploadExerciseVideo(
  file: Blob,
  deps: UploadExerciseVideoDeps = {},
): Promise<{ videoId: string; muted: boolean }> {
  const compress = deps.compress ?? compressExerciseVideo;
  const postJson = deps.postJson ?? defaultPostJson;

  const { blob, durationSec, muted } = await compress(file);
  const title = deps.name?.trim();

  const reserved = (await postJson(
    '/videos/uploads',
    title ? { title } : undefined,
  )) as {
    videoId: string;
    uploadUrl: string;
  };

  let status: number;
  try {
    const response = await fetch(reserved.uploadUrl, {
      method: 'PUT',
      body: blob,
    });
    status = response.status;
  } catch {
    throw new Error('Не удалось отправить ролик');
  }

  // Disk usually answers 201/202; some edges reply 200 after the body is stored.
  if (status !== 200 && status !== 201 && status !== 202) {
    throw new Error('Не удалось отправить ролик');
  }

  const completed = (await postJson(`/videos/${reserved.videoId}/complete`, {
    durationSec,
  })) as { videoId: string };

  return { videoId: completed.videoId, muted };
}
